import { Stack, Typography } from "@mui/material";
import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";

const maxAddressesToShow = 2;

const InvoicesActionsToolbar = () => {
  const [inboxAddressesResp, fetchError] = useFetch(adminApi.getExpenseManagementInboxAddresses);

  if (fetchError) {
    logError(fetchError, "[InvoicesActionsToolbar] getExpenseManagementInboxAddresses");
    return null;
  }

  if (!inboxAddressesResp?.addresses) {
    return null;
  }

  const addresses = inboxAddressesResp.addresses.slice(0, maxAddressesToShow);
  if (addresses.length === 0) {
    return null;
  }

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", pr: 1 }}>
      <Typography color="textSecondary" sx={{ pr: 0.5 }}>
        Email your invoice to
      </Typography>
      {addresses.map((address, index) => (
        <Stack key={address} direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
          {index > 0 && <Typography color="textSecondary">or</Typography>}
          <Typography>{address}</Typography>
          <CopyToBufferButton textToCopy={address} />
        </Stack>
      ))}
    </Stack>
  );
};

export default InvoicesActionsToolbar;
